import * as R from 'ramda'
import mergeConfig from 'coact/config/mergeConfig'

import schema from '../../utils/schema/index.js'

import purchaseReqs from './purchaseReqs.js'
import purchaseItems from './purchaseItems.js'
import purchaseOrders from './purchaseOrders.js'
import purchaseOrderItems from './purchaseOrderItems.js'

const adaptClientModel = R.over(R.lensProp('schema'), schema.adaptClient)

const config = {
  models: {
    purchaseReqs: adaptClientModel(purchaseReqs),
    purchaseItems: adaptClientModel(purchaseItems),
    purchaseOrders: adaptClientModel(purchaseOrders),
    purchaseOrderItems: adaptClientModel(purchaseOrderItems),
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
